import React, { useEffect, useState } from "react";
import UserPage from "../../user-page/UserPage";
import { useNavigate } from "react-router-dom";
import UserPageComponents from "../../user-page/user-page-components/UserPageComponents";
import AdminPageComponents from "../../admin-page/admin-page-components/AdminPageComponents";
import "./style.css";
import LoginHeader from "../login-header/LoginHeader";
import Welcome from "../welcome/Welcome";
import {setSessionCookie, getCookie} from "../../utils/cookieUtils";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";


const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [unauthorizedModalOpen, setUnauthorizedModalOpen] = useState(false);
  
  const handleLogin = async (event) => {
    event.preventDefault();
  
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/percept_db/v1/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ suid: username }),
        }
      );
  
      if (!response.ok) {
        if (response.status === 401) {
          // Unauthorized response, show the unauthorized modal
          setUnauthorizedModalOpen(true);
        } else {
          throw new Error("Invalid username");
        }
      } else {
        const data = await response.json();
        const userRole = data.role;
        setIsAdmin(data.is_admin);
        setLoggedIn(true);
        setSessionCookie('X-Spl-Username-Header', username);
      }
    } catch (error) {
      console.error("Excepted!");
    }
  };
  
  const handleLogout = () => {
    setLoggedIn(false);
    setIsAdmin(false);
    navigate("/login");
  };
  
  useEffect(() => {
    if (loggedIn){
      if (isAdmin) {        
        navigate("/admin-page");        
      } else {        
        navigate("/user-page");
      }
    }
  }, [loggedIn, isAdmin, navigate]);

  return (
    <div>
      <LoginHeader />
      <div>
        <div style={{ padding: "8px 12px", textAlign: "center" }}>
          <h2>Welcome to the</h2>
        </div>
        <img src="./images/SPL_percept.jpg" alt="Listener Rating System" class="imageStyle" />
        <div style={{ padding: "8px 12px", textAlign: "center" }}>
          <h2>Listener Rating System</h2>
        </div>
        <div class="center">
            <form onSubmit={handleLogin}>
            <label>Enter your SU NetID to login:
                <br /><br/>
                <input
                  type="text"
                  value={username}
                  onChange={(event) => setUsername(event.target.value)}
                  placeholder="SU NetID"
                />
              </label>
              <br /> <br />
              <button type="submit">Login</button>
            </form>
        </div>
        <p>For technical assistance, contact nrbenway@syr.edu.</p>
        <footer style={{ textAlign: "center", position: "fixed", bottom: "0", width: "100%" }}>
          <hr style={{ borderTop: "1px solid #ccc", width: "100%", margin: "5px auto" }} />
          <p>© 2023 - Syracuse University</p>
        </footer>
      </div>
      <Dialog open={unauthorizedModalOpen} onClose={() => setUnauthorizedModalOpen(false)}>
        <DialogContent>
          <div style={{ color: "#000E54", textAlign: "center" }}>
           '{username}' user doesn't have access.
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUnauthorizedModalOpen(false)} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Login;
